import { ProjectDto } from "./Project";
import { SquirrelSessionRequest } from "./SquirrelSession";

export class DocStereoTypeDto {
    id!: string;
    name!: string;
    menuPart!: string;
}

export class DocStereoTypesDto {
    pageSize!: number;
    totalCount!: number;
    docStereoTypes!: DocStereoTypeDto[];
}

export class DoStereoTypeResolved {
    docStereoTypeDto!: DocStereoTypeDto;
    error?: any
}

export class GenericDocumentData {
    squirrelSession!: SquirrelSessionRequest;
    projectDto!: ProjectDto;
    docStereoTypes!: DocStereoTypeDto[];

}